import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core'; // Import Capacitor

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  /**
   * Hide the custom GIF splash screen.
   */
  hide() {
    const splash = document.getElementById('custom-splash');
    if (splash) {
      splash.style.display = 'none';
    } else {
      console.error('Custom splash screen not found');
    }
  }

  /**
   * Show the custom GIF splash screen for a specified duration only on Capacitor platforms.
   * @param showDuration The duration to show the splash screen, in milliseconds.
   */
  show({ showDuration = 0 } = {}) {
    // Only show splash screen on Capacitor (native) platforms
    if (Capacitor.isNativePlatform()) {
      const splash = document.getElementById('custom-splash');
      if (splash) {
        splash.style.display = 'flex'; // Show the splash screen
      } else {
        console.error('Custom splash screen not found');
      }

      // If showDuration is specified, hide splash screen after the specified time
      if (showDuration > 0) {
        setTimeout(() => {
          this.hide(); // Hide the splash screen after the specified duration
        }, showDuration);
      }
    }
  }
}

// import { Injectable } from '@angular/core';
// import { SplashScreen } from '@capacitor/splash-screen';

// @Injectable({
//   providedIn: 'root',
// })
// export class SplashScreenService {
//   async hide() {
//     await SplashScreen.hide();
//   }

//   async show({ autoHide = true, showDuration = 0 } = {}) {
//     await SplashScreen.show({
//       autoHide,
//       showDuration,
//     });
//   }
// }
